<template>
    <div>
        <List>
            <router-link
                v-for="item in items"
                :key="item.routeName"
                :to="{ name: item.routeName }"
            >
                <ListItem>
                    <div class="l-inline l-gap-3 l-center-v">
                        <div>
                            <component :is="item.icon" width="24" height="24" />
                        </div>

                        <div>{{ item.label }}</div>
                    </div>
                </ListItem>
            </router-link>
        </List>
    </div>
</template>

<script>
import AlarmBellTimerIcon from '@/components/icons/AlarmBellTimerIcon'
import AnalyticsGraphIcon from '@/components/icons/AnalyticsGraphIcon'
import DashboardIcon from '@/components/icons/DashboardIcon'
import HistoryClockIcon from '@/components/icons/HistoryClockIcon'
import List from '@/components/List'
import ListItem from '@/components/ListItem'
import ReportIcon from '@/components/icons/ReportIcon'
import WarningOutlinedIcon from '@/components/icons/WarningOutlinedIcon'

export default {
    name: 'ArvMenu',
    components: {
        List,
        ListItem,
    },
    computed: {
        items() {
            return [
                {
                    icon: DashboardIcon,
                    label: this.$t('dashboard'),
                    routeName: 'arvDashboard',
                },
                {
                    icon: HistoryClockIcon,
                    label: this.$t('activities'),
                    routeName: 'arvActivities',
                },
                {
                    icon: AlarmBellTimerIcon,
                    label: this.$t('deadlines'),
                    routeName: 'arvDeadlines',
                },
                {
                    icon: WarningOutlinedIcon,
                    label: this.$t('violations'),
                    routeName: 'arvViolations',
                },
                {
                    icon: AnalyticsGraphIcon,
                    label: this.$t('evaluations'),
                    routeName: 'arvEvaluations',
                },
                {
                    icon: ReportIcon,
                    label: this.$t('reports'),
                    routeName: 'arvReports',
                },
            ]
        },
    },
}
</script>

<i18n>
{
    "en": {
        "activities": "Activities",
        "dashboard": "Dashboard",
        "deadlines": "Deadlines",
        "evaluations": "Evaluations",
        "reports": "Reports",
        "violations": "Violations"
    },
    "de": {
        "activities": "Aktivitäten",
        "dashboard": "Dashboard",
        "deadlines": "Fristen",
        "evaluations": "Auswertungen",
        "reports": "Berichte",
        "violations": "Verstösse"
    },
    "fr": {
        "activities": "Activités",
        "dashboard": "Tableau de bord",
        "deadlines": "Échéances",
        "evaluations": "Analyses",
        "reports": "Rapports",
        "violations": "Infractions"
    },
    "it": {
        "activities": "Attività",
        "dashboard": "Dashboard",
        "deadlines": "Scadenze",
        "evaluations": "Valutazioni",
        "reports": "Rapporti",
        "violations": "Violazioni"
    }
}
</i18n>

<style lang="scss" scoped>
a {
    &.router-link-active {
        .list-item {
            background-color: $color-gray-light;
        }
    }

    svg {
        display: block;
    }
}
</style>
